(function () {
  'use strict';

  var isMobile = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  function createViewer(glbUrl) {
    var viewer = document.createElement('model-viewer');
    viewer.className = 'product-card-3d-viewer';
    viewer.src = glbUrl;
    viewer.setAttribute('auto-rotate', '');
    viewer.setAttribute('auto-rotate-delay', '0');
    viewer.setAttribute('rotation-per-second', '30deg');
    viewer.setAttribute('interaction-prompt', 'none');
    viewer.setAttribute('disable-zoom', '');
    viewer.setAttribute('camera-orbit', '0deg 75deg 105%');
    viewer.setAttribute('shadow-intensity', '0');
    return viewer;
  }

  function openViewer(gallery) {
    var glbUrl = gallery.dataset.hasGlb;
    if (!glbUrl || gallery.querySelector('.product-card-3d-viewer')) return;
    gallery.classList.add('model-active');
    gallery.appendChild(createViewer(glbUrl));
  }

  function closeViewer(gallery) {
    var viewer = gallery.querySelector('.product-card-3d-viewer');
    if (viewer) viewer.remove();
    gallery.classList.remove('model-active');
  }

  function closeAllExcept(current) {
    document.querySelectorAll('.card-gallery[data-has-glb].model-active').forEach(function (g) {
      if (g !== current) closeViewer(g);
    });
  }

  document.querySelectorAll('.card-gallery[data-has-glb]').forEach(function (gallery) {
    if (isMobile) {
      gallery.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (gallery.classList.contains('model-active')) {
          closeViewer(gallery);
        } else {
          closeAllExcept(gallery);
          openViewer(gallery);
        }
      }, true);
    } else {
      gallery.addEventListener('pointerenter', function () {
        openViewer(gallery);
      });
      gallery.addEventListener('pointerleave', function () {
        closeViewer(gallery);
      });
    }
  });
})();
